import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import api from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Något gick fel. Försök igen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <Header />
      <div className="max-w-md mx-auto px-4 py-16">
        <Mail className="w-10 h-10 text-brand mb-4" />
        <p className="label-overline mb-2">Återställ lösenord</p>
        <h1 className="font-display font-black uppercase text-white text-4xl mb-6">Glömt lösenord?</h1>

        {sent ? (
          <div className="card-surface p-6 space-y-4" data-testid="forgot-success">
            <p className="text-white">
              Om <span className="text-brand font-bold">{email}</span> finns hos oss skickas ett mail med en återställningslänk inom kort. Kolla även skräpposten.
            </p>
            <p className="text-white/60 text-sm">Länken är giltig i 60 minuter.</p>
            <Link to="/photographer/login" className="inline-flex items-center gap-2 text-brand hover:underline text-sm">
              <ArrowLeft className="w-4 h-4" /> Tillbaka till inloggning
            </Link>
          </div>
        ) : (
          <>
            <p className="text-white/70 mb-4 text-sm">
              Skriv din e-postadress så skickar vi en länk för att välja ett nytt lösenord.
            </p>
            <form onSubmit={submit} className="card-surface p-6 space-y-4" data-testid="forgot-form">
              <div>
                <label className="label-overline block mb-1">E-post</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input-field"
                  placeholder="namn@exempel.se"
                  data-testid="forgot-email"
                />
              </div>
              {err && <p className="text-destructive text-sm" data-testid="forgot-error">{err}</p>}
              <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="forgot-submit">
                {loading ? "Skickar..." : "Skicka återställningslänk"}
              </button>
            </form>
            <p className="text-white/60 text-sm mt-4 text-center">
              <Link to="/photographer/login" className="hover:text-brand inline-flex items-center gap-1" data-testid="back-to-login">
                <ArrowLeft className="w-3 h-3" /> Tillbaka till inloggning
              </Link>
            </p>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
